import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useStarterPackMixins } from '@/modules/starter/pack/model/mixins';
import { ROUTE_NAME_STARTER } from '@/modules/starter/pack/router';
import { starterPackService } from '@/services/starter';

export function useStarterPackAdd() {
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { model, v$, iapOptions } = useStarterPackMixins();

    const actions = {
        create: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                starterPackService.create(
                    model.name,
                    model.packageId,
                    model.price,
                    model.amount,
                    model.displayRate,
                    model.gameRequired,
                    model.durationSeconds,
                    model.imageFile,
                    model.isDefault
                ),
            onSuccess: () => router.push({ name: ROUTE_NAME_STARTER.PACK.INDEX })
        })
    };

    return { model, v$, actions, iapOptions };
}
